import React from "react";

interface PartnersProps {
  sectionRef: (el: HTMLElement | null) => void;
}

const Partners: React.FC<PartnersProps> = ({ sectionRef }) => {
  return (
    <section ref={sectionRef} className="w-full py-40 md:py-60 bg-white border-y border-text-primary/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
        <div className="text-text-secondary font-black text-[10px] uppercase tracking-[0.5em] mb-12">Trusted Partners / Protocol Integrations</div>
        <h2 className="text-4xl md:text-6xl font-black text-text-primary mb-24 uppercase tracking-tighter">
          A Global <span className="text-secondary italic">Trust Network.</span>
        </h2>
        <div className="grid grid-cols-1 gap-12 items-center opacity-40 hover:opacity-100 transition-opacity">
          {[
            { name: "Mysalaryloan", url: "https://mysalaryloan.com" }
          ].map((partner, i) => (
            <a
              key={i}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative cursor-pointer grayscale hover:grayscale-0 transition-all p-10 border border-transparent hover:border-text-primary/10 hover:bg-text-primary/5 inline-block mx-auto"
            >
              <span className="text-3xl md:text-5xl font-black text-text-primary uppercase tracking-tighter">{partner.name}</span>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-1 bg-secondary group-hover:w-full transition-all" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
